// pages/Admin.jsx
//
// Thin orchestrator. All heavy lifting lives in:
//   • ./admin/AdminShared  — TABS, charts, cards, helpers, OverviewTab
//   • ./admin/AdminPanels  — Users, Moderation, Support, Analytics, System
import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { Shield } from "lucide-react";

import { TABS, PendingBadge, OverviewTab } from "./admin/AdminShared";
import {
  UsersTab, ModerationTab, SupportTab, AnalyticsTab, SystemTab,
} from "./admin/AdminPanels";

export default function Admin() {
  const [activeTab, setActiveTab] = useState("overview");
  const [pendingCounts, setPendingCounts] = useState({});
  const [initialSub, setInitialSub] = useState(null);

  useEffect(() => {
    api.get("/admin/overview")
      .then((res) => setPendingCounts(res.data.pending || {}))
      .catch(() => {});
  }, [activeTab]);

  const goTo = (tab, sub) => {
    setActiveTab(tab);
    setInitialSub(sub || null);
  };

  const moderationPending = (pendingCounts.reports || 0) + (pendingCounts.share_claims || 0);
  const supportPending = (pendingCounts.support_tickets || 0) + (pendingCounts.feedback || 0) + (pendingCounts.dsr_requests || 0);

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex items-center gap-2 mb-6">
          <Shield className="w-6 h-6 text-purple-600" />
          <h1 className="font-display text-2xl font-semibold">Admin</h1>
        </div>

        <div className="flex flex-wrap gap-1.5 mb-6 border-b border-[#E7E5E0] pb-2">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const badge =
              tab.key === "moderation" ? moderationPending :
              tab.key === "support" ? supportPending : 0;
            return (
              <button
                key={tab.key}
                onClick={() => goTo(tab.key)}
                className={`px-4 py-2 rounded-full text-sm font-medium flex items-center gap-1.5 transition-colors ${
                  activeTab === tab.key
                    ? "bg-purple-600 text-white"
                    : "bg-white border border-[#E7E5E0] text-[#0F0F10] hover:bg-[#F5F3EE]"
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
                {badge > 0 && activeTab !== tab.key && <PendingBadge count={badge} />}
              </button>
            );
          })}
        </div>

        {activeTab === "overview" && <OverviewTab onGoTo={goTo} />}
        {activeTab === "users" && <UsersTab />}
        {activeTab === "moderation" && <ModerationTab initialSub={initialSub} />}
        {activeTab === "support" && <SupportTab initialSub={initialSub} />}
        {activeTab === "analytics" && <AnalyticsTab initialSub={initialSub} />}
        {activeTab === "system" && <SystemTab initialSub={initialSub} />}
      </main>
    </div>
  );
}